import { Box, Button, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Icons } from "./../Icons";
import moment from "moment";
import ModalTrazabilidad from "./../ModalTrazabilidad";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
}

const getColumns = ({
  handleVerClick,
  urlOrigen
}: ColumnsProps): GridColDef[] => {
  return [
    {
      field: "acciones",
      headerName: "Acciones",
      headerAlign: "left",
      width: 200,
      sortable: false,
      hideable: false,
      renderCell: (cellValues: any) => {
        return (
          <Box display="flex" alignItems="center">
            <Box sx={{ paddingLeft: "5px", cursor: 'pointer' }} ml={2} onClick={() => handleVerClick(cellValues.id, '/admin/configuracion/usuarios/edita/')}>
              {Icons("Visibility")}
            </Box>
          </Box>
        );
      },
    },
    {
      field: "nombre",
      headerName: "Nombre",
      width: 230,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        return <p>
          {cellValues.row.Nombre + " "}
          {cellValues.row.ApellidoPaterno + " "}
          {cellValues.row.ApellidoMaterno}
        </p>;
      },
    },
    {
      field: "correo",
      headerName: "Correo",
      width: 200,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        return <p>{cellValues.row.CorreoElectronico}</p>;
      },
    },
    {
      field: "usuario",
      headerName: "Usuario",
      width: 200,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        return <p>{cellValues.row.NombreUsuario}</p>;
      },
    },
    {
      field: "roles",
      headerName: "Roles",
      width: 200,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        const roles = Array.isArray(JSON.parse(cellValues.row.Roles)) ? JSON.parse(cellValues.row.Roles) : [];
        return <p>{roles.map((item: { Rol: string }) => item.Rol).join(", ") || "Sin rol"}</p>;
      }
    },
    {
      field: "FechaDeCreacion",
      headerName: "Creado",
      width: 200,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        const formattedDate = moment(cellValues.row.FechaDeCreacion).format(
          "DD/MM/YY HH:mm"
        );
        return <p>{formattedDate + " Hrs"}</p>;
      },
    },
  ];
};

export default getColumns;
